var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 6,
    fill: "#337FFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8078 12.7495L15.1497 10.5788H13.0433V9.1678C13.0433 8.57424 13.3374 7.99426 14.2777 7.99426H15.2489V6.14575C14.6833 6.05565 14.1119 6.0069 13.5391 5.99991C11.8054 5.99991 10.6736 7.04117 10.6736 8.92359V10.5788H8.75178V12.7495H10.6736V17.9999H13.0433V12.7495H14.8078Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.24b915126c200cd1b4fce87884d391ca.svg";
export { ForwardRef as ReactComponent };